
import React from 'react';
import { LucideDashboardIcons } from '../../shared/LucideDashboardIcons';

function MetricCard({ title, value, iconName, trend, progress, onClick }) {
  const LucideIcon = LucideDashboardIcons[iconName] || LucideDashboardIcons.default;
  return (
    <div
      className="metric-card"
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onClick(); } } : undefined}
      style={onClick ? { cursor: 'pointer' } : undefined}
    >
      <div className="metric-header">
        <h3>{title}</h3>
        <span className="metric-icon">{LucideIcon && <LucideIcon size={22} strokeWidth={1.5} />}</span>
      </div>
      <div className="metric-value">{value}</div>
      {trend && (
        <div className={`metric-trend ${trend.startsWith('-') ? 'negative' : 'positive'}`}>
          {trend}
        </div>
      )}
      {progress !== undefined && (
        <div className="metric-progress">
          <div className="progress-bar">
            <div
              className="progress-fill"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <span className="progress-text">{progress}%</span>
        </div>
      )}
    </div>
  );
}

export default MetricCard;
